module.exports = __webpack_public_path__ + "img/sms_signalizator_zabudovaná SIM karta.7cba7f52.webp";